"use client"

import { useEffect } from "react"
import { captureException } from "@/lib/analytics/posthog"
import { ErrorView } from "@/components/error/error-view"
// global-error replaces the root layout, so the layout's globals.css import is
// bypassed - re-import it here or the theme tokens (Tailwind) won't apply.
import "./globals.css"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // global-error catches errors thrown in the root layout itself. Report
    // before rendering the fallback.
    captureException(error, { boundary: "app/global-error", digest: error.digest })
  }, [error])

  return (
    <html lang="en">
      <body className="font-sans antialiased">
        <ErrorView error={error} reset={reset} />
      </body>
    </html>
  )
}
